<template>
    <div>
        <div class="overflow-x-auto">
            <table class="table">
                <thead>
                    <tr>
                        <th width="40%">Adress</th>
                        <th>Grävd</th>
                        <th>Installerad</th>
                        <th>Redo för driftsättning</th>
                        <th>Driftsatt</th>
                    </tr>
                </thead>
                <tbody>
                    <delivery-project-address-item
                        v-for="address in addresses.data"
                        :key="address.id"
                        :delivery-project="deliveryProject"
                        :initial-address="address"
                        :company="company"
                        :phases="phases"
                        :company-phases="companyPhases"
                        @toggleAddressSelected="toggle"
                    />
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import AddressesList from '../../DeliveryProjects/Addresses/AddressesList';
    import DeliveryProjectAddressItem from './AddressListItem';

    export default {
        components: {
            DeliveryProjectAddressItem,
        },
        extends: AddressesList,
        props: {
            company: {
                type: Object,
                required: true,
            },
            phases: {
                type: Array,
                required: true,
            },
            companyPhases: {
                type: Array,
                required: true,
            },
        },
    };
</script>
